import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Swal from 'sweetalert2';
import { Link, useSearchParams } from 'react-router-dom';
import { getCases } from '../../actions/case-actions';
import { formatDate, searchQuery } from '../../actions/global-actions';
import { BsFillTrashFill, BsSearch, BsArrowUp, BsArrowDown } from "react-icons/bs";
import DatePicker from 'react-date-picker';
import Paginator from '../../components/paginator/paginator';
import { isNumeric, itemsPerPage, provinces } from '../../actions/global-actions-data';
import '../../styles/cases.css';
import { territorialEntity } from './case-data';

function CasesList(){
    const currentLink = "/casos";
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const [cases, setCases] = useState([]);
    const [loadData, setLoadData] = useState(true);
    const [isFirstTime, setIsFirstTime] = useState(true);
    const user = useSelector(state => state.user.user);
    const [showContainer, setShowContainer] = useState(false);
    const [isSearched, setIsSearched] = useState(false);
    const [citiesData, setCitiesData] = useState({
        caseCities: [],
        clientCities: []
    });
    const [paginatorData, setPaginatorData] = useState({
        totalitems: 0,
        totalpages: 0,
        currentpage: 0
    });

    const setSkipValue = () => {
        let page = searchParams.get('page') || 0;
        if (!isNumeric(page)) return 0;
        if (parseInt(page) < 1) return 0;
        page = (parseInt(page)-1) * itemsPerPage;
        return page;
    }

    const [skip, setSkip] = useState(setSkipValue());

    const setParamValue = (name) => {
        if (name === 'date' || name === 'endDate') return searchParams.get(name)?new Date(searchParams.get(name)):'';
        //console.log(name, searchParams.get(name));
        return searchParams.get(name) || '';
    }

    const [form, setForm] = useState({
        date: setParamValue('date'),
        endDate: setParamValue('endDate'),
        filingNumber: setParamValue('filingNumber'),
        clientID: setParamValue('clientID'),
        clientText: setParamValue('clientText'),
        attorneyID: setParamValue('attorneyID'),
        attorneyText: setParamValue('attorneyText'),
        organ: setParamValue('organ'),
        province: setParamValue('province'),
        city: setParamValue('city'),
        legalCompany: setParamValue('legalCompany'),
        status: setParamValue('status'),
        representative: setParamValue('representative'),
        position: setParamValue('position'),
        statePosition: setParamValue('statePosition'),
        territorialEntity: setParamValue('territorialEntity'),
        executionProvince: setParamValue('executionProvince'),
        executionCity: setParamValue('executionCity'),
    });

    const [dropdown, setDropdown] = useState({
        show: false,
        value: '',
        data: []
    })
    
    useEffect(() => {
        const getFunction = (response) => {
            let data = response.data;
            if(data.code === "01"){
                Swal.fire({
                    title:"Error",
                    confirmButtonColor:"#76b4ff",
                    text: data.message
                });
                return;
            }
            console.log('response', data.data);

            if (data.data && data.data.length > 0) {
                for (let index = 0; index < data.data.length; index++) {
                    let type = data.data[index].caseType;
                    data.data[index].caseType = type.charAt(0).toUpperCase() + type.slice(1);
                    data.data[index].legalCompany = data.data[index].legalCompany? data.data[index].legalCompany: 'AYH';
                    if (data.data[index].status === "not checked") {
                        data.data[index].status = "Sin revisar"
                    }
                    if (data.data[index].status === "checked") {
                        data.data[index].status = "Revisado"
                    }
                    if (data.data[index].status === "finished") {
                        data.data[index].status = "Terminado"
                    }
                }
            }
            setCases(data.data);

            setPaginatorData({
                ...paginatorData,
                ...response.headers,
            })
        }

        const setCitiesValues = () => {
            const provinceValue = searchParams.get('province')?searchParams.get('province'):'';
            const executionProvinceValue = searchParams.get('executionProvince')?searchParams.get('executionProvince'):'';
            let caseCities = [];
            let clientCities = [];
            const caseProvince = provinces.find( x => x.name === provinceValue);
            const clientProvince = provinces.find( x => x.name === executionProvinceValue);
            if (caseProvince) {
                caseCities = caseProvince.cities;
            }
            if (clientProvince) {
                clientCities = clientProvince.cities;
            }
            setCitiesData({
                caseCities: caseCities,
                clientCities: clientCities
            })
        }

        const setIsSearchedValue = () => {
            let params = Object.fromEntries([...searchParams]);
            delete params.page;
            if (Object.keys(params).length>0) {
                setShowContainer(true);
                setIsSearched(true);
            }
        }

        if (loadData) {
            setLoadData(false);
            setCases([]);
            dispatch( getCases( form, skip, getFunction, user.token ) );
            if (isFirstTime) {
                setIsFirstTime(false);
                setCitiesValues();
                setIsSearchedValue();
            }
        }
    }, [loadData, dispatch, user.token, form, skip, paginatorData, isFirstTime, searchParams ]);

    const toggleContainer = () => {
        setShowContainer(!showContainer)
    }
    
    const handleDateChange = ( name, date ) => {
        if (!date) {
            setForm({
                ...form,
                [name] :  ''
            });
            return;
        }
        setForm({
            ...form,
            [name] :  date
        })
    }

    const handleInputChange = (event) => {
        setForm({
            ...form,
            [event.target.name] :  event.target.value
        })
    }

    const handleOnChange = (event, position) => {
        const value = event.target.value;
        if (value !== '' && value) {
            const cities = provinces.find( x => x.name === value).cities;
            if (position === 'case') {
                setCitiesData({
                    ...citiesData,
                    caseCities: cities
                })
                setForm({
                    ...form,
                    [event.target.name]: event.target.value,
                    city: ''
                });
                return;
            }

            setCitiesData({
                ...citiesData,
                clientCities: cities
            })
            setForm({
                ...form,
                [event.target.name]: event.target.value,
                executionCity: ''
            });
            return;
      
        }
        if (position === 'case') {
            setCitiesData({
                ...citiesData,
                caseCities: []
            })
            setForm({
                ...form,
                city :  '',
                province: ''
            })
            return;
        }

        setCitiesData({
            ...citiesData,
            clientCities: []
        })
        setForm({
            ...form,
            executionCity :  '',
            executionProvince: ''
        })            
    }

    const handleSearchChange = (option, event) => {
        if (event.target.value.length > 2) {
            setForm({
                ...form,
                [event.target.name] :  event.target.value
            });
            dispatch( searchQuery( event.target.id, event.target.value, responseFunction, user.token ) );
            return;
        }
        if (option === 1) {
            setForm({
                ...form,
                [event.target.name] :  event.target.value,
                attorneyID: ''
            });
        } else {
            setForm({
                ...form,
                [event.target.name] :  event.target.value,
                clientID: ''
            });
        }
        setDropdown({ show: false, value: '', data: [] });
    }

    const responseFunction = ( link, data ) => {
        if(data.code === "01"){
            Swal.fire({
                title:"Error",
                confirmButtonColor:"#76b4ff",
                text: data.message
            });
        }else{
            //console.log(data);
            setDropdown({ show: true, value: link, data: data.data });
        }
    }

    const setAttorneyData = ( data ) => {
        setForm({
            ...form,
            attorneyID: data._id,
            attorneyText: `${data.firstName} ${data.lastName} ${data.documentType} ${data.document} TP: ${data.professionalCard}`,
        })
        setDropdown({ show: false, value: '', data: [] });
    }

    const setClientData = ( data ) => {
        setForm({
            ...form,
            clientID: data._id,
            clientText: `${data.firstName} ${data.lastName} ${data.documentType} ${data.document}`,
        })
        setDropdown({ show: false, value: '', data: [] });
    }

    const deleteSearch = () => {
        setForm({
            date: '',
            endDate: '',
            filingNumber: '',
            clientID: '',
            clientText: '',
            attorneyID: '',
            attorneyText: '',
            organ: '',
            province: '',
            city: '',
            legalCompany: '',
            status: '',
            representative: '',
            position: '',
            statePosition: '',
            territorialEntity: '',
            executionProvince: '',
            executionCity: '',
        })
        setCitiesData({
            caseCities: [],
            clientCities: []
        })
        setSearchParams({});
        stockPaginator();
        setIsSearched(false);
        setLoadData(true);
    }

    const stockPaginator = () => {
        setSkip(0);
        setPaginatorData({
            totalitems: 0,
            totalpages: 0,
            currentpage: 0
        });
    }

    const searchFunction = () => {
        const isEmpty = validateFields();
        if (isEmpty) {
            Swal.fire({
                title:"¡Atención!",
                confirmButtonColor:"#76b4ff",
                text:"Debe llenar algún campo para continuar",
            });
            return;
        } else {
            setSearchParams(form);
            stockPaginator();
            setIsSearched(true);
            setLoadData(true);
        }
    }

    const validateFields = () => {
        for (const field in form) {
            if (form.hasOwnProperty(field)) {
                //console.log(`${field}: ${form[field]}`);
                if ( form[field] !== '' && form[field] ) {
                    return false
                }
            }
        }
        return true
    }

    useEffect(() => {
        console.log(form)
        //console.log(skip)
    }, [form]);

    return(
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <h1 className="my-5">Casos jurídicos</h1>
                <div className="d-flex flex-column w-100">
                    <div onClick={toggleContainer} style={{ width: 'fit-content', cursor: 'pointer'}}>
                        <h4 className="w-100 my-2 d-flex"> Búsqueda
                            {showContainer?
                                <BsArrowUp className="arrow-icon"/>
                            :
                                <BsArrowDown className="arrow-icon"/>
                            }
                        </h4>
                    </div>
                    {showContainer &&
                        <div className="w-100 d-flex flex-wrap">
                            <h5 className='filter-text w-100'>Datos del caso</h5>
                            <span className='w-100 m-2'><i>Para buscar un caso de una fecha específica solo ponga la fecha de inicio</i></span>
                            <div className="d-flex flex-column w-25 field">
                                <label className="label-field">Fecha inicio</label>
                                <DatePicker
                                    value={ form.date }
                                    dayAriaLabel={"Día"}
                                    dayPlaceholder={"dd"}
                                    monthAriaLabel={"Mes"}
                                    monthPlaceholder={"mm"}
                                    yearAriaLabel={"Año"}
                                    yearPlaceholder={"yyyy"}
                                    name={"date"}
                                    onChange={ (date)=>handleDateChange( 'date', date ) }
                                    dateFormat="MM/dd/yyyy"
                                />
                            </div>
                            <div className="d-flex flex-column w-25 field">
                                <label className="label-field">Fecha fin</label>
                                <DatePicker
                                    value={ form.endDate }
                                    dayAriaLabel={"Día"}
                                    dayPlaceholder={"dd"}
                                    monthAriaLabel={"Mes"}
                                    monthPlaceholder={"mm"}
                                    yearAriaLabel={"Año"}
                                    yearPlaceholder={"yyyy"}
                                    name={"date"}
                                    onChange={ (date)=>handleDateChange( 'endDate', date ) }
                                    dateFormat="MM/dd/yyyy"
                                />
                            </div>
                            <div className="d-flex flex-column w-25 field">
                                <label className="label-field" htmlFor="filingNumber">Radicado</label>
                                <input type="text" className="input-field" id="filingNumber" name="filingNumber" autoComplete="off" placeholder="No de radicado" onChange={handleInputChange} value={form.filingNumber}></input>
                            </div>
                            <div className="d-flex flex-column w-25 field position-relative">
                                <label className="label-field" htmlFor="user">Abogado</label>
                                <input id="user" name="attorneyText" type="text" autoComplete='off' className="input-field"  placeholder="Nombre, apellido o documento" onChange={(e)=>handleSearchChange(1,e)} value={form.attorneyText}></input>
                                <div className={`dropdown-container ${(dropdown.show && dropdown.value === 'user') ? "active" : ""}`}>
                                    { dropdown.data.length > 0 ?
                                        dropdown.data.map((option, index) => (
                                            <div key={index} className="dropdown-item-container" onClick={() => setAttorneyData(option)}>{option.firstName} {option.lastName} {option.documentType} {option.document} TP: {option.professionalCard}</div>
                                        ))
                                    :
                                        <span className="dropdown-message-item">Sin resultados  
                                            { user.userType === 'Administrador'?<a target="_blank" rel="noreferrer" href={"/usuarios/nuevo"}>, ¿crear?</a> : null}                        
                                        </span>
                                    }
                                </div>
                            </div>
                            <div className="d-flex flex-column w-25 field">
                                <label className="label-field" htmlFor="organ">Órgano de investigación</label>
                                <input type="text" className="input-field" id="organ" name="organ" autoComplete="off" placeholder="Buscar órgano por su nombre" onChange={handleInputChange} value={form.organ}></input>
                            </div>
                            <div className="d-flex flex-column w-25 field">
                                <label className="label-field" htmlFor="province">Departamento</label>
                                <select className="input-field" id="province" name="province" onChange={(e) =>handleOnChange(e, 'case')} value={form.province}>
                                    <option></option>
                                    {provinces.map((province) => (
                                        <option key={province.name} value={province.name}>{province.name}</option>
                                    ))}
                                </select>
                            </div>
                            {form.province !== '' && citiesData.caseCities && citiesData.caseCities !== [] && 
                                <div className="d-flex flex-column w-25 field">
                                    <label className="label-field" htmlFor="city">Ciudad del caso</label>
                                    <select className="input-field" id="city" name="city" onChange={handleInputChange} value={form.city}>
                                        <option></option>
                                        {citiesData.caseCities.map((city) => (
                                            <option key={city.name} value={city.name}>{city.name}</option>
                                        ))}
                                    </select>
                                </div>
                            }
                            <div  className="d-flex flex-column w-25 field">
                                <label className="label-field" htmlFor="legalCompany">Empresa</label>
                                <select className="input-field" id="legalCompany" name="legalCompany" onChange={handleInputChange} value={form.legalCompany}>
                                    <option value=""></option>
                                    <option value="AYH">AYH</option>
                                    <option value="VAF">VAF</option>
                                </select>
                            </div>
                            <div className="d-flex flex-column w-25 field">
                                <label className="label-field" htmlFor="representative">Personero &#47; Funcionario</label>
                                <input type="text" className="input-field" id="representative" name="representative" autoComplete="off" placeholder="" onChange={handleInputChange} value={form.representative}></input>
                            </div>
                            <div  className="d-flex flex-column w-25 field">
                                <label className="label-field" htmlFor="status">Estado del caso</label>
                                <select className="input-field" id="status" name="status" onChange={handleInputChange} value={form.status}>
                                    <option value=""></option>
                                    <option value="Abierto">Abierto</option>
                                    <option value="Cerrado">Cerrado</option>
                                </select>
                            </div>
                            <h5 className='filter-text w-100'>Datos del cliente</h5>
                            <div className="d-flex flex-column w-25 field position-relative">
                                <label className="label-field" htmlFor="client">Cliente</label>
                                <input id="client" name="clientText" type="text" autoComplete='off' className="input-field"  placeholder="Nombre, apellido o documento" onChange={(e)=>handleSearchChange(2,e)} value={form.clientText}></input>
                                <div className={`dropdown-container ${(dropdown.show && dropdown.value === 'client') ? "active" : ""}`}>
                                    { dropdown.data.length > 0 ?
                                        dropdown.data.map((option, index) => (
                                            <div key={index} className="dropdown-item-container" onClick={() => setClientData(option)}>{option.firstName} {option.lastName} {option.documentType} {option.document}</div>
                                        ))
                                    :
                                        <span className="dropdown-message-item">Sin resultados  
                                            { user.userType === 'Administrador'?<a target="_blank" rel="noreferrer" href={"/clientes/nuevo"}>, ¿crear?</a> : null}                        
                                        </span>
                                    }
                                </div>
                            </div>
                            <div className="d-flex flex-column w-25 field">
                                <label className="label-field" htmlFor="position">Cargo</label>
                                <input type="text" className="input-field" id="position" name="position" autoComplete="off" onChange={handleInputChange} value={form.position}></input>
                            </div>
                            <div  className="d-flex flex-column w-25 field">
                                <label className="label-field" htmlFor="statePosition">Estado del cargo</label>
                                <select className="input-field" id="statePosition" name="statePosition" onChange={handleInputChange} value={form.statePosition}>
                                    <option value=""></option>
                                    <option value="actual">Actualmente</option>
                                    <option value="ex">Ex</option>
                                </select>
                            </div>
                            <div  className="d-flex flex-column w-25 field">
                                <label className="label-field" htmlFor="territorialEntity">Entidad territorial</label>
                                <select className="input-field" id="territorialEntity" name="territorialEntity" onChange={handleInputChange} value={form.territorialEntity}>
                                    <option value=""></option>
                                    {territorialEntity.map((value) => (
                                        <option key={'territorialEntity' + value} value={value}>{value}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="d-flex flex-column w-25 field">
                                <label className="label-field" htmlFor="executionProvince">Departamento de ejecución</label>
                                <select className="input-field" id="executionProvince" name="executionProvince" onChange={(e) =>handleOnChange(e, 'client')} value={form.executionProvince}>
                                    <option></option>
                                    {provinces.map((province) => (
                                        <option key={province.name} value={province.name}>{province.name}</option>
                                    ))}
                                </select>
                            </div>
                            {form.executionProvince !== '' && citiesData.clientCities && citiesData.clientCities !== [] && 
                                <div className="d-flex flex-column w-25 field">
                                    <label className="label-field" htmlFor="executionCity">Ciudad de ejecución</label>
                                    <select className="input-field" id="executionCity" name="executionCity" onChange={handleInputChange} value={form.executionCity}>
                                        <option></option>
                                        {citiesData.clientCities.map((city) => (
                                            <option key={'executionCity' + city.name} value={city.name}>{city.name}</option>
                                        ))}
                                    </select>
                                </div>
                            }
                            <div className="w-100 d-flex justify-content-center m-2">
                                <div className="d-flex search-button with-text justify-content-center align-items-center" onClick={searchFunction}>
                                    <span>Buscar</span>
                                    <BsSearch/>
                                </div>
                            </div>
                            <div className="w-100 d-flex justify-content-center my-1">
                                <span className="delete-search-text" onClick={deleteSearch}>
                                    Eliminar búsqueda
                                </span>
                            </div>
                        </div>
                    }
                    <div className="w-100 d-flex justify-content-between mt-3 mb-1">
                        <span className='align-self-center'>Casos <b>{ form.status!==''&& isSearched ?form.status.toLocaleLowerCase()+'s':null}</b>: <b>{paginatorData.totalitems}</b></span>
                        <Link to={currentLink + "/nuevo"} className="primary-button">Añadir un nuevo caso +</Link>
                    </div>
                </div>
                {user.userType === 'Administrador' ?
                    <table className="list-table my-3">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Fecha</th>
                                <th>Radicado</th>
                                <th>Tipo Inv.</th>
                                <th>Abogado</th>
                                <th>Cliente</th>
                                <th>Detalles</th>
                                <th>Empresa</th>
                                <th>Estado</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {cases.map((caseItem, index) => (
                                <tr key={index}>
                                    <td> <Link to={currentLink + `/editar/${caseItem._id}`} key={caseItem._id}>{ (index+1) + skip }</Link> </td>
                                    <td> <Link to={currentLink + `/editar/${caseItem._id}`} key={caseItem._id} className='inline-text'>{formatDate(caseItem.date, 4)}</Link> </td>
                                    <td> <Link to={currentLink + `/editar/${caseItem._id}`} key={caseItem._id} className='inline-text'>{caseItem.filingNumber}</Link> </td>
                                    <td> <Link to={currentLink + `/editar/${caseItem._id}`} key={caseItem._id}>{caseItem.caseType}</Link> </td>
                                    <td> <Link to={currentLink + `/editar/${caseItem._id}`} key={caseItem._id}>{caseItem.attorneyInCharge.userId.firstName} {caseItem.attorneyInCharge.userId.lastName}</Link> </td>
                                    <td> <Link to={currentLink + `/editar/${caseItem._id}`} key={caseItem._id}>{caseItem.client.clientId.firstName} {caseItem.client.clientId.lastName}</Link> </td>
                                    <td> <Link to={currentLink + `/editar/${caseItem._id}`} key={caseItem._id}>{caseItem.case.position} No.{caseItem.autoOpening}</Link> </td>
                                    <td> <Link to={currentLink + `/editar/${caseItem._id}`} key={caseItem._id}>{caseItem.legalCompany}</Link> </td>
                                    <td> <Link to={currentLink + `/editar/${caseItem._id}`} key={caseItem._id}>{caseItem.status}</Link> </td>
                                    <td>
                                        <BsFillTrashFill className='trash-icon' />
                                    </td>
                                </tr> 
                            ))}
                        </tbody>
                    </table>
                :
                    <table className="list-table my-3">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Fecha</th>
                                <th>Radicado</th>
                                <th>Tipo Inv.</th>
                                <th>Abogado</th>
                                <th>Cliente</th>
                                <th>Detalles</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cases.map((caseItem, index) => (
                                <tr key={index}>
                                    <td> <Link to={currentLink + `/editar/${caseItem._id}`} key={caseItem._id}>{ (index+1) + skip }</Link> </td>
                                    <td> <Link to={currentLink + `/editar/${caseItem._id}`} key={caseItem._id} className='inline-text'>{formatDate(caseItem.date, 4)}</Link> </td>
                                    <td> <Link to={currentLink + `/editar/${caseItem._id}`} key={caseItem._id} className='inline-text'>{caseItem.filingNumber}</Link> </td>
                                    <td> <Link to={currentLink + `/editar/${caseItem._id}`} key={caseItem._id}>{caseItem.caseType}</Link> </td>
                                    <td> <Link to={currentLink + `/editar/${caseItem._id}`} key={caseItem._id}>{caseItem.attorneyInCharge.userId.firstName} {caseItem.attorneyInCharge.userId.lastName}</Link> </td>
                                    <td> <Link to={currentLink + `/editar/${caseItem._id}`} key={caseItem._id}>{caseItem.client.clientId.firstName} {caseItem.client.clientId.lastName}</Link> </td>
                                    <td> <Link to={currentLink + `/editar/${caseItem._id}`} key={caseItem._id}>{caseItem.case.position} No.{caseItem.autoOpening}</Link> </td>
                                </tr> 
                            ))}
                        </tbody>
                    </table>
                }
                {paginatorData.totalpages > 0 && paginatorData.currentpage > 0 &&
                    <Paginator 
                        data={paginatorData}
                        skip={skip}
                        setSkip={(n) => setSkip(n)}
                        setLoadData={(need) => setLoadData(need)}
                        queryParams={searchParams}
                        setQueryParams={(params) => setSearchParams(params)}
                    />
                }
            </div>
        </div>
    );
}

export default CasesList;
  